export default "__VITE_ASSET__BWmHz7q6__"